export default "__VITE_ASSET__Dvp7f3bU__"